<template>
  <layout name="Settings">
    <div>
      <VSettingsSidebarLayoutHeading
        title="Address Validation"
        :buttons="buttons"
      />

      <div class="account-notifications-form__wrapper">
        <AccountSettingsFormAdvanced
          :initialValues="{
            intl_validation: _user && _user.intl_validation,
            us_validation: _user && _user.us_validation
          }"
        />
      </div>

      <!--<div class="account-advanced__details">-->
      <!--For more information,-->
      <!--<a href="#" target="_blank"> checkout our documentation</a>-->
      <!--</div>-->
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import Layout from "@/layouts/Layout";

// components
import VSettingsSidebarLayoutHeading from "@/components/VSettingsSidebarLayoutHeading";
import AccountSettingsFormAdvanced from "@/components/AccountSettingsFormAdvanced";

// mixins
import withToasted from "@/mixins/withToasted";
import withFormUtils from "@/mixins/withFormUtils";

export default Vue.component("AccountAddressValidation", {
  metaInfo: {
    title: "Settings - Advanced"
  },

  components: {
    Layout,
    VSettingsSidebarLayoutHeading,
    AccountSettingsFormAdvanced
  },

  data() {
    return {
      name: "accountSettingsAdvanced"
    };
  },

  methods: {
    _cancel() {
      this._initializeForm();
      this.clearFormErrors();
      this.setFormTouchedValue();
    },

    _initializeForm() {
      const { us_validation, intl_validation } = this.getUser;

      this.initializeForm({
        formName: this.name,
        fields: {
          us_validation,
          intl_validation
        }
      });
    },

    saveSettings() {
      this.validateForm();

      if (this.isValid) {
        this.updateUser({
          values: this.formValues,
          onSuccess: this.saveSettingsUpdate,
          onError: () =>
            this.toast("Something went wrong. Try again later.", "error")
        });
      }
    },

    saveSettingsUpdate() {
      this.updateValues({
        formName: this.name,
        fields: this.formValues
      });

      this.setFormTouchedValue();

      this.toast("Your settings have been saved!", "success", {
        icon: "check "
      });
    },

    ...mapActions("account", ["updateUser"]),
    ...mapActions("forms", ["updateValues"])
  },

  mixins: [withToasted, withFormUtils],

  computed: {
    buttons() {
      if (!this.isFormTouched("accountSettingsAdvanced")) {
        return [];
      }

      return [
        {
          key: "cancel",
          size: "narrow",
          label: "Reset",
          type: "primary",
          inverted: true,
          noBorder: true,
          onClickHandler: this._cancel
        },

        {
          key: "save",
          type: "primary",
          label: "Save",
          size: "regular",
          onClickHandler: this.saveSettings,
          disabled: this.isLoading
        }
      ];
    },

    _user() {
      return this.getUser;
    },

    ...mapGetters("account", ["isLoading", "getUser"])
  }
});
</script>

<style lang="scss" scoped>
.account-advanced__details {
  margin-top: 40px;
  color: #131e2c;
  font-size: 14px;

  a {
    color: #7c8ca3;
  }
}
</style>

<style lang="scss">
button.dark.inverted.account-save-button {
  color: #7c8ca3;
  border-color: #7c8ca3;

  &:hover {
    color: $primary-color;
    border-color: $primary-color;
    background: transparent;
  }
}
</style>
